import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { HttpMethods } from 'api/types';
import cn from 'classnames';
import { Backdrop } from 'components/Common';
import Layout from 'components/Layout/Layout';
import MoreArtPrints from 'components/StudioSearchProductPage/MoreArePrints/MoreArtPrints';
import StudioBundleProducts, {
  getBundleGroups,
} from 'components/StudioSearchProductPage/StudioBundleProducts/StudioBundleProducts';
import StudioDeliveryOptions from 'components/StudioSearchProductPage/StudioDeliveryOptions/StudioDeliveryOptions';
import StudioOPPlusFreeShipping from 'components/StudioSearchProductPage/StudioOPPlusFreeShipping/StudioOPPlusFreeShipping';
import StudioPostAddToCartFlow from 'components/StudioSearchProductPage/StudioPostAddToCartFlow/StudioPostAddToCartFlow';
import StudioProductAttributes from 'components/StudioSearchProductPage/StudioProductAttributes/StudioProductAttributes';
import StudioProductDetails from 'components/StudioSearchProductPage/StudioProductDetails/StudioProductDetails';
import StudioProductPreviewDesktop from 'components/StudioSearchProductPage/StudioProductPreviewDesktop/StudioProductPreviewDesktop';
import StudioProductPreviewMobile from 'components/StudioSearchProductPage/StudioProductPreviewMobile/StudioProductPreviewMobile';
import StudioProductPrice from 'components/StudioSearchProductPage/StudioProductPrice/ProductPrice';
import StudioProductSizes from 'components/StudioSearchProductPage/StudioProductSizes/StudioProductSizes';
import StudioProductTitle from 'components/StudioSearchProductPage/StudioProductTitle/StudioProductTitle';
// import StudioSimilarImages from 'components/StudioSearchProductPage/StudioSimilarImages/StudioSimilarImages';
import StudioSupportMaterials from 'components/StudioSearchProductPage/StudioSupportMaterials/StudioSupportMaterials';
import StudioUspsPremium from 'components/StudioSearchProductPage/StudioUspsPremium/StudioUspsPremium';
import useQuery from 'hooks/useQuery';
import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps, useHistory, useLocation } from 'react-router-dom';
import { Store } from 'store';
import getLanguagePrefix from 'store/app/selector/getLanguagePrefix';
import getOpRoute from 'store/app/selector/getOpRoute';
import isDesktop from 'store/app/selector/isDesktop';
import changeAttributeOperation from 'store/publicAssetProduct/operation/changeAttributeOperation';
import fetchPublicAssetProductTypesOperation from 'store/publicAssetProduct/operation/fetchPublicAssetProductTypesOperation';
// import fetchMoreArtPrintsOperation from 'store/publicAssetProduct/operation/fetchMoreArtPrintsOperation';
// import fetchSimilarImagesOperation from 'store/publicAssetProduct/operation/fetchSimilarImagesOperation';
import navigateToEditorOperation from 'store/publicAssetProduct/operation/navigateToEditorOperation';
import getCurrentProduct from 'store/publicAssetProduct/selector/getCurrentProduct';
import getForcedPreviews from 'store/publicAssetProduct/selector/getForcedPreviews';
import getPublicAssetAbstractProductData from 'store/publicAssetProduct/selector/getPublicAssetAbstractProductData';
import getPubicAssetImagePreview from 'store/publicAssetProduct/selector/getPubicAssetImagePreview';
import getProductId from 'store/publicAssetProduct/selector/getProductId';
import getSelectedAbstractProduct from 'store/publicAssetProduct/selector/getSelectedAbstractProduct';
import getSelectedAbstractProductName from 'store/publicAssetProduct/selector/getSelectedAbstractProductName';
import getSelectedBundleProducts from 'store/publicAssetProduct/selector/getSelectedBundleProducts';
import {
  setAddingToCartFlowAction,
  setCurrentProductAction,
  setSelectedBundleProductsAction,
  setSourceAction,
  setSourceImageIdAction,
} from 'store/publicAssetProduct/slice';
import fetchPricesOperation from 'store/price/operation/fetchPricesOperation';
import setPricesToFetchOperation from 'store/price/operation/setPricesToFetchOperation';
import { PricesToFetch } from 'store/price/types';
import { AddToCartFlow } from 'store/product/types';
import fetchStudioSearchCategoryDataOperation from 'store/studioSearch/operation/fetchStudioSearchCategoryDataOperation';
import getStudioSearchCategory from 'store/studioSearch/selector/getStudioSearchCategory';
import gtmChangeAttributeEvent from 'utils/gtm/gtmChangeAttributeEvent';
import gtmSendEvent from 'utils/gtm/gtmSendEvent';
import gtmSendFunnelStepEvent, { FUNNEL_STEPS } from 'utils/gtm/gtmSendFunnelStepEvent';
import OpButton from 'components/Common/op-ui-wrappers/OpButton/OpButton';
import storeRecentlyViewedOperation from 'store/studioSearch/operation/storeRecentlyViewedOperation';
import RecentlyViewedBlock from 'components/Common/RecentlyViewed/RecentlyViewedBlock';
import OpShippingInfo from 'components/Common/OpShippingInfo/OpShippingInfo';
import OpStickyBar from 'components/Common/OpStickyBar/OpStickyBar';
import getPublicAssetImageDesignName from 'store/publicAssetProduct/selector/getPublicAssetImageDesignName';
import gtmGettyEditDesignEvent from 'utils/gtm/gtmGettyEditDesignEvent';
import OpFavourite from 'components/Common/op-ui-wrappers/OpFavourite/OpFavourite';
import fetchAssetDetailsById from 'store/publicAssetProduct/operation/fetchAssetDetailsById';
import ProductSelector from 'components/StudioSearchProductPage/ProductSelector/ProductSelector';
import checkIfSticky from 'utils/checkIfSticky';
import AttributeSelectionMobilePopup from 'components/StudioSearchPage/AttributeSelectionMobilePopup/AttributeSelectionMobilePopup';
import AddToBasketButtonPremium from 'components/StudioSearchProductPage/AddToBasketButtonPremium/AddToBasketButtonPremium';
import EditDesignButton from 'components/StudioSearchProductPage/EditDesignButton/EditDesignButton';
import HelloBar from 'components/Common/HelloBar/HelloBar';
import getAddingToCartFlow from 'store/publicAssetProduct/selector/getAddingToCartFlow';
import LastOrderDate from 'components/Common/LastOrderDate/LastOrderDate';
import useAddToBasket from 'hooks/StudioSearchProductPage/useAddToBasket';
import pickBetterImageFormatOperation from 'store/publicAssetProduct/operation/pickBetterImageFormatOperation';
import getPublicAssetImageDescription from 'store/publicAssetProduct/selector/getPublicAssetImageDescription';
import styles from './StudioSearchProductPage.module.scss';

export interface StudioSearchProductPageRouteParams {
  source: string;
  sourceId: string;
  slug?: string;
  preselectProductSlug?: string;
}

const StudioSearchProductPage: FC<RouteComponentProps<StudioSearchProductPageRouteParams>> = ({ match }) => {
  const query = useQuery();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();
  const isBetterImageFormatSelected = useRef(false);
  const mainImageAspectRatio = useRef<number>(0);
  const isDesktopDevice = useSelector(isDesktop);
  const selectedProductTypeId = 173;
  const productId = useSelector(getProductId);
  const publicAssetAbstractProductData = useSelector(getPublicAssetAbstractProductData);
  const currentProduct = useSelector(getCurrentProduct);
  const imagePreview = useSelector(getPubicAssetImagePreview);
  const designName = useSelector(getPublicAssetImageDesignName);
  const imageDescription = useSelector(getPublicAssetImageDescription);
  const stickyButtonRef = useRef<HTMLDivElement>(null);
  const [refetchRecentlyViewed, setRefetchRecentlyViewed] = useState(0);

  const selectedAbstractProduct = useSelector(getSelectedAbstractProduct);
  const selectedAbstractProductName = useSelector(getSelectedAbstractProductName);
  const selectedBundleProducts = useSelector(getSelectedBundleProducts);
  const forcedProductPreviews = useSelector(getForcedPreviews);
  const [encryptedDesignId, setEncryptedDesignId] = useState<number>();
  const [frameUpsellData, setFrameUpsellData] =
    useState<AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response>();
  const [frameUpsellSelectedFrame, setFrameUpsellSelectedFrame] = useState<number>();
  const [showProductSelector, setShowProductSelector] = useState(true);
  const currentAddToCartFlow = useSelector(getAddingToCartFlow);
  const basketRoute = useSelector((store: Store) => getOpRoute(store, 1));
  const langPrefix = useSelector(getLanguagePrefix);
  const category = useSelector(getStudioSearchCategory);
  const history = useHistory();
  const { lastOrderItemId } = useAddToBasket(match, setEncryptedDesignId);

  const setCurrentAddToCartFlow = (addToCartFlow: AddToCartFlow) => {
    dispatch(setAddingToCartFlowAction(addToCartFlow));
  };

  const betterFormatPickedCallback = () => {
    isBetterImageFormatSelected.current = true;
  };

  const pickBetterFormat = (force = false) => {
    if (!force && isBetterImageFormatSelected.current) return;
    dispatch(pickBetterImageFormatOperation(mainImageAspectRatio.current, betterFormatPickedCallback));
  };

  const registerMainImageAspectRatio = (width: number, height: number) => {
    mainImageAspectRatio.current = width / height;
    pickBetterFormat();
  };

  useEffect(() => {
    if (publicAssetAbstractProductData && publicAssetAbstractProductData.products.length < 2) {
      setShowProductSelector(false);
    } else {
      setShowProductSelector(true);
    }
  }, [publicAssetAbstractProductData]);

  const frameUpsellSelected = () => {
    return frameUpsellData?.items[frameUpsellSelectedFrame || 0];
  };

  const frameUpsellProductId = () => {
    return frameUpsellData?.items[frameUpsellSelectedFrame || 0].productId;
  };

  const frameUpsellProductDescription = () => {
    return frameUpsellData?.items[frameUpsellSelectedFrame || 0].productDescription;
  };

  const frameUpsellProductTitle = () => {
    return frameUpsellData?.items[frameUpsellSelectedFrame || 0].name;
  };

  const frameUpsellProductPreviewUrl = () => {
    return frameUpsellData?.items[frameUpsellSelectedFrame || 0].previewUrl;
  };

  const postAddToCartFlowAddToBasketCallback = () => {
    const categoryId = currentProduct?.categoryId;
    const productTypeId = currentProduct?.productTypeId;

    if (!basketRoute?.path) return;

    window.location.href = `${langPrefix}${basketRoute?.path}?categoryId=${categoryId}&productTypeId=${productTypeId}`;
  };

  const currentProductDescription = () => {
    if (!currentProduct) {
      return undefined;
    }
    const currProd = currentProduct as any;
    return imageDescription || currProd.content.productDescription;
  };

  const currentProductPopup = () => {
    if (!currentProduct) {
      return undefined;
    }
    const currProd = currentProduct as any;
    return currProd.content.productDetailsPopup;
  };

  const currentProductSizes = () => {
    if (!currentProduct) {
      return undefined;
    }
    const currProd = currentProduct as any;
    return currProd.content.productSizeDetailsImage;
  };

  const selectedAbstractProductUsps = () => {
    if (!selectedAbstractProduct) {
      return undefined;
    }
    const selProd = selectedAbstractProduct as any;
    return selProd.usps;
  };

  const getAbstractProductSelectors = () => {
    return selectedAbstractProduct?.productPageSelectors || [];
  };

  const getCurrentProductAttributes = () => {
    return currentProduct?.attributes || [];
  };

  const navigateBackUrl = useMemo(() => query.get('from') || '', [query]);

  const navigateBackToSearch = () => {
    history.push(navigateBackUrl);
  };

  const navigateToEditor = async () => {
    const { source } = match.params;
    if (designName) {
      gtmSendEvent(gtmGettyEditDesignEvent(designName));
    }
    dispatch(navigateToEditorOperation(source));
  };

  const changeAttribute = (typeName: string, value: string, defaultProductId: number) => {
    gtmSendEvent(gtmChangeAttributeEvent(typeName, value));
    dispatch(changeAttributeOperation(typeName, value, defaultProductId));
  };

  const fetchUpsellData = async () => {
    const productItem = currentProduct;
    if (!productItem) {
      return;
    }
    let response;
    try {
      response = (await apiRequest(
        endpoints.upsellV1Screen,
        {
          designId: encryptedDesignId,
        },
        HttpMethods.GET,
        'data',
      )) as AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response;

      if (!response) {
        throw new Error('No response');
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Cannot fetch editor screen upsell data');
      return;
    }
    const upsellData = response.items.length > 0 ? response : undefined;
    setFrameUpsellData(upsellData);

    if (!upsellData) {
      return;
    }

    // apply voucher
    try {
      await apiRequest(
        endpoints.cartV1VoucherAdd,
        {
          code: response.voucher,
        },
        HttpMethods.POST,
        'data',
      );
      // eslint-disable-next-line no-empty
    } catch {
      // eslint-disable-next-line no-console
      console.error('Error applying voucher code');
    }

    const pricesToUpdate: PricesToFetch = {};
    upsellData.items.forEach((item) => {
      const itemCategoryId = item.categoryId;
      if (!itemCategoryId) {
        return;
      }

      if (!pricesToUpdate[itemCategoryId]) {
        pricesToUpdate[itemCategoryId] = {
          categoryId: Number(itemCategoryId),
          productIds: [],
          encryptedDesignId: encryptedDesignId?.toString(),
        };
      }
      pricesToUpdate[itemCategoryId].productIds.push(item.productId);
    });
    dispatch(setPricesToFetchOperation(pricesToUpdate));
    await dispatch(fetchPricesOperation());
  };

  const frameUpsellAddToBasket = async () => {
    if (!lastOrderItemId) {
      return Promise.resolve(false);
    }

    if (!selectedBundleProducts || !selectedBundleProducts.length) {
      return Promise.resolve(false);
    }

    setCurrentAddToCartFlow(AddToCartFlow.bundlingProduct);

    return Promise.all(
      selectedBundleProducts.map((selectedProduct) =>
        apiRequest(
          endpoints.cartV1ProductAdd,
          {
            bundleOwnerOrderItemId: lastOrderItemId,
            categoryId: selectedProduct.categoryId,
            includeAnalytics: true,
            productId: selectedProduct.productId,
            quantity: 1,
          },
          HttpMethods.POST,
          'data',
        ),
      ),
    )
      .then(() => {
        setCurrentAddToCartFlow(AddToCartFlow.bundlingCompleted);
      })
      .catch(() => {
        setCurrentAddToCartFlow(AddToCartFlow.bundlingFailed);
      });
  };

  const needToShowAttributeSelectionPopup = () => {
    if (isDesktopDevice) return false;
    if (!stickyButtonRef || !stickyButtonRef.current) return false;
    stickyButtonRef.current.style.position = 'sticky';
    return checkIfSticky(stickyButtonRef.current);
  };

  const selectFrameCallback = (
    frame: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response.IUpsellItem,
    frameIndex: number,
  ) => {
    const { categoryId, productId: pID } = frame;
    setFrameUpsellSelectedFrame(frameIndex);
    const availableBundleGroups = getBundleGroups(currentProduct?.productId || 1, selectedAbstractProduct) || [];
    let productItemToSelect: any;
    const bundleGroup = availableBundleGroups.find((bg) => {
      productItemToSelect = bg.items?.find((item) => item.productId === pID);
      return productItemToSelect;
    });
    if (!bundleGroup || !productItemToSelect) {
      return;
    }

    const { bundleGroupId, canSelectMultiple: useMultipleSelection } = bundleGroup;

    const alreadySelected = selectedBundleProducts?.find(
      (sp) => sp.bundleGroupId === bundleGroupId && sp.productId === productItemToSelect.productId,
    );
    if (alreadySelected) {
      return;
    }
    // remove none option
    let updatedSelectedBundledProduts =
      selectedBundleProducts?.filter((sp) => !(sp.bundleGroupId === bundleGroupId && sp.productId === 0)) || [];

    if (!useMultipleSelection) {
      // remove already selected options
      updatedSelectedBundledProduts = selectedBundleProducts?.filter((sp) => sp.bundleGroupId !== bundleGroupId) || [];
    }
    updatedSelectedBundledProduts.push({
      bundleGroupId,
      productId: productItemToSelect.productId,
      categoryId: parseInt(categoryId || '', 10),
    });

    dispatch(setSelectedBundleProductsAction(updatedSelectedBundledProduts));
  };

  const initProductPage = async () => {
    dispatch(setCurrentProductAction());
    gtmSendFunnelStepEvent(FUNNEL_STEPS.productPageSearchResult);
    dispatch(setSourceImageIdAction(match.params.sourceId || ''));
    dispatch(setSourceAction(match.params.source || ''));
    Promise.all([
      dispatch(
        fetchPublicAssetProductTypesOperation(
          match.params.source,
          match.params.sourceId || '',
          match.params.slug,
          match.params.preselectProductSlug,
        ),
      ),
      dispatch(fetchAssetDetailsById(match.params.source, match.params.sourceId, match.params.slug)),
      dispatch(fetchStudioSearchCategoryDataOperation()),
    ]).then(() => {
      pickBetterFormat(true);
      dispatch(storeRecentlyViewedOperation(match.params.sourceId, match.params.source, match.params.slug));
      setRefetchRecentlyViewed((prev) => prev + 1);
    });
    // TODO: Enable more art prints and similar images when we move to Clerk
    // dispatch(fetchGettyImageByIdOperation(parseInt(match.params.sourceId, 10)) as unknown as Promise<void>).then(() => {
    // dispatch(fetchMoreArtPrintsOperation())
    // dispatch(fetchSimilarImagesOperation());
    // });
  };

  useEffect(() => {
    initProductPage();
  }, [location]);

  return (
    <>
      <Layout
        itemType="http://schema.org/Product"
        itemScope
        className={styles.studioTheme}
        prefix={
          <>
            <OpStickyBar />
            <HelloBar content={category?.helloBar} className={styles.helloBar} />
          </>
        }
      >
        <meta itemProp="brand" content="Optimalprint" />
        {navigateBackUrl && (
          <div className={styles.backToSearch} onClick={() => navigateBackToSearch()}>
            <OpButton size="small" variant="secondary" icon-left="carret-left">
              {t('txt_back_to_search')}
            </OpButton>
          </div>
        )}

        <div className={cn(styles.productPage, { [styles.mobile]: !isDesktopDevice })}>
          {isDesktopDevice && (
            <div className={cn(styles.column, styles.previews)}>
              <StudioProductPreviewDesktop
                imagePreview={imagePreview || ''}
                originalPreviews={currentProduct?.previews || []}
                forcedPreviews={forcedProductPreviews || {}}
                onMainImageLoaded={registerMainImageAspectRatio}
              />
              {currentProduct?.sku && (
                <div className={styles.favouriteIcon}>
                  <OpFavourite
                    sku={currentProduct.sku}
                    productTier={currentProduct.productTier}
                    categoryId={currentProduct.categoryId}
                  />
                </div>
              )}
            </div>
          )}
          {!isDesktopDevice && (
            <div className={styles.previews}>
              <StudioProductPreviewMobile
                productTypeId={selectedProductTypeId}
                originalPreviews={currentProduct?.previews || []}
                forcedPreviews={forcedProductPreviews || {}}
                imagePreview={imagePreview || ''}
                onMainImageLoaded={registerMainImageAspectRatio}
              />
              {currentProduct?.sku && (
                <div className={styles.favouriteIcon}>
                  <OpFavourite
                    sku={currentProduct.sku}
                    productTier={currentProduct.productTier}
                    categoryId={currentProduct.categoryId}
                  />
                </div>
              )}
            </div>
          )}
          <div className={cn(styles.column, styles.dataColumn)}>
            <div className={styles.titleContainer}>
              <StudioProductTitle />
            </div>
            <StudioProductPrice
              categoryId={currentProduct?.categoryId || 1}
              productId={currentProduct?.productId || 1}
              quantity={1}
              inOneLine={!isDesktopDevice}
            />
            <OpShippingInfo productId={productId || 1} quantity={1} />
            {showProductSelector && (
              <div className={styles.dropdownSelector}>
                <ReactPlaceholder
                  showLoadingAnimation
                  type="rect"
                  ready={!!(publicAssetAbstractProductData && selectedAbstractProductName)}
                  style={{ width: '100%', height: '22px', backgroundColor: '#e8e8e8', marginBottom: '10px' }}
                >
                  <div className={styles.selectorName}>{t('txt_select_product')}</div>
                </ReactPlaceholder>
                <ReactPlaceholder
                  showLoadingAnimation
                  type="rect"
                  ready={!!(publicAssetAbstractProductData && selectedAbstractProductName)}
                  style={{ width: '100%', height: '40px', backgroundColor: '#e8e8e8' }}
                >
                  <ProductSelector />
                </ReactPlaceholder>
              </div>
            )}

            <StudioProductAttributes
              studioProductPageSelectors={getAbstractProductSelectors()}
              currentProductAttributes={getCurrentProductAttributes()}
              currentProductItem={currentProduct}
              allProducts={selectedAbstractProduct?.products || []}
              changeAttribute={changeAttribute}
              productId={productId || 1}
            />
            <StudioBundleProducts
              abstractProduct={selectedAbstractProduct}
              productId={currentProduct?.productId || 1}
            />
            <div
              ref={stickyButtonRef}
              className={cn(styles.buttonContainer, { [styles.stickyButton]: !isDesktopDevice })}
            >
              <AddToBasketButtonPremium
                primary
                openMobilePopupCheck={needToShowAttributeSelectionPopup}
                setEncryptedDesignId={setEncryptedDesignId}
                match={match}
              />
              <EditDesignButton onEditHandler={navigateToEditor} />
            </div>

            {currentProduct && (
              <>
                <LastOrderDate type="sm" theme="default" productId={currentProduct?.productId} />
                <StudioOPPlusFreeShipping
                  categoryId={currentProduct?.categoryId || 1}
                  productId={currentProduct?.productId || 1}
                />
                <StudioUspsPremium usps={selectedAbstractProductUsps()} />
                <div className={styles.blockContainer}>
                  <StudioProductDetails
                    productDescription={currentProductDescription()}
                    productDetailsPopup={currentProductPopup()}
                  />
                  <StudioProductSizes productSideDescriptionImage={currentProductSizes()} />
                  <StudioDeliveryOptions
                    categoryId={currentProduct?.categoryId || 1}
                    productId={currentProduct?.productId || 1}
                  />
                </div>
              </>
            )}
            {currentProduct && (
              <StudioSupportMaterials supportMaterials={(currentProduct as any).supportingMaterials} />
            )}
          </div>
        </div>
        <div className={styles.space} />
        <Backdrop />
        {!isDesktopDevice && (
          <AttributeSelectionMobilePopup>
            <AddToBasketButtonPremium primary setEncryptedDesignId={setEncryptedDesignId} match={match} />
            <EditDesignButton onEditHandler={navigateToEditor} />
          </AttributeSelectionMobilePopup>
        )}
        {/* <AddToBasketCounterTracker />  */}
        {/* <div className={styles.block}>
          <StudioSimilarImages />
        </div> */}
        {/* <div className={styles.block}>
          <MoreArtPrints />
        </div> */}
        <div className={styles.block}>
          <RecentlyViewedBlock theme="default" forceRender={refetchRecentlyViewed} />
        </div>
        <StudioPostAddToCartFlow
          currentAddToCartFlow={currentAddToCartFlow}
          goToBasketCallback={postAddToCartFlowAddToBasketCallback}
          frameUpsellData={frameUpsellData}
          activeFrameProductId={frameUpsellProductId()}
          addToBasketCallback={frameUpsellAddToBasket}
          categoryId={currentProduct?.categoryId || 1}
          frameDescription={frameUpsellProductDescription()}
          frameProductId={frameUpsellProductId()}
          frameTitle={frameUpsellProductTitle()}
          frames={frameUpsellData?.items || []}
          popupTitle={frameUpsellData?.title || ''}
          previewUrl={frameUpsellProductPreviewUrl() || ''}
          selectFrameCallback={selectFrameCallback}
          selectedFrame={frameUpsellSelected()}
          voucher={frameUpsellData?.voucherText || ''}
          fetchFrameUpsellData={fetchUpsellData}
        />
      </Layout>
    </>
  );
};

export default StudioSearchProductPage;
